import { addDays, format } from "date-fns";
import { DateFormat, UTC, fromISODate, isISODate } from "#/shared/lib/helpers/date";

/** Number of days a preview covers, start date included. */
const PREVIEW_DAYS = 30;

/**
 * Returns the last date a preview starting on `startDate` covers, as `Y-m-d`: `"2026-12-20"` → `"2027-01-18"`.
 * Returns "" when `startDate` is not a valid `Y-m-d` date.
 *
 * @param {String} startDate
 * @returns {String}
 */
export function previewEndDate(startDate) {
  if (!isISODate(startDate)) {
    return "";
  }

  return format(addDays(fromISODate(startDate), PREVIEW_DAYS - 1, UTC), DateFormat.ISO, UTC);
}

/**
 * Returns a `Y-m-d` date as `mm/dd/yyyy`, the padded format `sp-date-field` displays: `"2026-10-08"` → `"10/08/2026"`.
 * Returns "" for an invalid date.
 *
 * @param {String} value
 * @returns {String}
 */
export function formatDisplayDate(value) {
  return isISODate(value) ? format(fromISODate(value), "MM/dd/yyyy", UTC) : "";
}
